import { render, staticRenderFns } from "./RelatedRPDocsSectionValueEditor.vue?vue&type=template&id=2acb2e6c"
import script from "./RelatedRPDocsSectionValueEditor.vue?vue&type=script&lang=ts"
export * from "./RelatedRPDocsSectionValueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports